import RequirementModel from "./RequirementModel";

export default class GeneralRequirementModel extends RequirementModel {
  public postPoints: number = null;
  public postsCount: number = null;
  public reactionsCount: number = null;
  public totalDiscussionPoints: number = null;
}
